module.exports = __webpack_public_path__ + "img/audio-comment-null.15a96ffc.png";